import React, { FC, useMemo } from 'react'
import { JCMSCTAContainer } from '../JCMSCTAContainer'
import { JSectionHeaderTitle } from '../JHeaderTitle'
import { CMSSection } from './../models/CMSConfig'
import './JSection.scss'
import { JCMSCTA, JCMSCTAProps } from '../JCMSCTA'
export interface JCMSSectionProps extends CMSSection {
    context?: string,
    headingLevel?: 2 | 3,
    renderCTA?: boolean,
}

export const JSection: FC<JCMSSectionProps> = props => {
    if (props.enabled === false) return <></>

    const background = useMemo(() => props.options?.background || 'trasparent', [props.options?.background])
    const container = useMemo(() => props.options?.container || 'fluid', [props.options?.container])
    const headerCta = useMemo(() => props.options?.headerCta || null, [props.options])
    const context = useMemo(() => props.context || 'generic', [props.context])

    return (
        <div className={`jsection jsection-background-${background} jsection-context-${context} jsection-headerAlign-${props.options?.headerAlign || 'left'} ${headerCta ? 'with-cta' : ''}`} >
            <div className={`jsection-container jsection-container-${container}`}>
                {
                    (props.title || props.text || props.subTitle) && (
                        <JSectionHeaderTitle {...props} align={props.options?.headerAlign} headingLevel={props.headingLevel || 2} />
                    )
                }

                {headerCta && <div className={'jheadertitle-cta'}>
                    <JCMSCTA  {...headerCta as JCMSCTAProps} />
                </div>}


                {
                    props.children && (
                        <div>
                            {props.children}
                        </div>
                    )
                }
                {
                    props.renderCTA && !!props.cta?.length && (
                        <JCMSCTAContainer cta={props.cta} align={props.options?.headerAlign === 'center' ? 'center' : 'right'} />
                    )
                }
            </div>
        </div>
    )
}